import { CARRIER_STATE_KEY } from './carrierConstants';
import { createSelector } from 'reselect';
import insurancePickerSelector from '../insurancePickerSelector';

const carrierSelector = createSelector(
    insurancePickerSelector,
    insurance => insurance[CARRIER_STATE_KEY]
);

export default carrierSelector;
